const dba = {
  AGENCY_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Dígito da agência é obrigatório e deve ser numérico ou x',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_1'
  },
  ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Dígito da conta é obrigatório e deve ser numérico ou x',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_2'
  },
  AGENCY_ONE: {
    message: 'Agência deve ser 1',
    variable: undefined,
    field: 'agency',
    suggestion: '1',
    code: 'DBA_3'
  },
  INVALID_AGENCY_ONE: {
    message: 'Agência inválida',
    variable: undefined,
    field: 'agency',
    suggestion: '1',
    code: 'DBA_3'
  },
  AGENCY_MAX_LENGTH: {
    message: 'Agência é obrigatória e deve conter no máximo {{maxLength}} números',
    field: 'agency',
    variable: 'maxLength',
    code: 'DBA_4'
  },
  AGENCY_DIGIT_NUMERIC: {
    message: 'Dígito da agência deve ter apenas 1 dígito',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_5'
  },
  ACCOUNT_MAX_LENGTH: {
    message: 'Conta é obrigatória e deve conter no máximo {{maxLength}} números',
    field: 'account',
    variable: 'maxLength',
    code: 'DBA_6'
  },
  ACCOUNT_MAX_MIN_LENGTH: {
    message: 'Conta é obrigatória e deve conter entre {{minLength}} e {{maxLength}} números',
    field: 'account',
    variable: ['maxLength', 'minLength'],
    code: 'DBA_7'
  },
  ACCOUNT_DIGIT_NUMERIC: {
    message: 'Dígito da Conta é obrigatório e deve ter apenas 1 dígito',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_8'
  },
  ACCOUNT_EXACT_LENGTH: {
    message: 'Conta do banco é obrigatória e deve conter exatamente {{exactLength}} números',
    field: 'account',
    variable: 'exactLength',
    code: 'DBA_9'
  },
  ACCOUNT_TYPE: {
    message: 'Tipo de conta inválido',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ACCOUNT_TYPE_2: {
    message: 'Tipo da conta inválido.',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ACCOUNT_TYPE_3: {
    message: 'Tipo da conta do recebedor inválido.',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ: {
    message: "Tipo de conta 'Entidade pública' é disponível somente para CNPJ",
    field: 'account_type',
    variable: undefined,
    code: 'DBA_11'
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ_2: {
    message: "Tipo de conta 'Entidade pública' só permite pessoa jurídica.",
    field: 'account_type',
    variable: undefined,
    code: 'DBA_11'
  },
  INVALID_DOCUMENT: {
    message: 'Documento do recebedor não é um CPF nem CNPJ',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_12'
  },
  INVALID_DOCUMENT_2: {
    message: 'CPF/CNPJ é obrigatório',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_12'
  },
  INVALID_DOCUMENT_3: {
    message: 'Documento {{document}} não é um CPF ou CNPJ',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_12'
  },
  DOCUMENT_BLACKLIST_BLOCKED: {
    message: 'O CPF ou CNPJ está bloqueado',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_13'
  },
  DOCUMENT_BLACKLIST_BLOCKED_2: {
    message: 'Documento {{document}} está bloqueado',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_13'
  },
  BANK_NOT_FOUND: {
    message: 'Banco(s) não encontrado(s) por id ou código',
    field: 'bank',
    variable: undefined,
    code: 'DBA_14'
  },
  INVALID_NAME: {
    message: 'O nome é obrigatório',
    field: 'name',
    variable: undefined,
    code: 'DBA_15'
  },
  INVALID_EMAIL: {
    message: 'O e-mail deve ser válido',
    field: 'email',
    variable: undefined,
    code: 'DBA_16'
  },
  EDIT_NOT_ALLOWED: {
    message: 'Recebedor não pode ser editado quando estiver Pendente Verificação ou Verificado',
    field: 'status',
    variable: undefined,
    code: 'DBA_17'
  },
  REMOVE_NOT_ALLOWED_WITH_PROCESSING_TRANSFERS: {
    message: 'Recebedor não pode ser removido enquanto houverem transferências em processamento',
    field: undefined,
    variable: undefined,
    code: 'DBA_18'
  },
  INVALID_AGENCY_DIGIT: {
    message: 'Dígito da Agência não é válido',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_19'
  },
  ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Conta ou dígito verificador da conta inválido.',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_20'
  },
  INVALID_ACCOUNT_DIGIT: {
    message: 'Dígito verificador da conta inválido.',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_20'
  },
  INVALID_ACCOUNT: {
    message: 'Conta inválida.',
    field: 'account',
    variable: undefined,
    code: 'DBA_21'
  },
  AGENCY_DOES_NOT_EXIST: {
    message: 'Agência não existe',
    field: 'agency',
    variable: undefined,
    code: 'DBA_22'
  },
  DOCUMENT_DOEST_NOT_EXIST: {
    message: 'Documento não existe',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_23'
  },
  DOCUMENT_DOEST_NOT_EXIST_2: {
    message: 'Documento {{document}} não encontrado',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_23'
  },
  WRONG_DOCUMENT: {
    message: 'Nome informado não coincide com o nome no Documento',
    field: 'name',
    variable: undefined,
    code: 'DBA_24'
  },
  EMPTY_PAYLOAD: {
    message: 'Payload é obrigatório',
    field: undefined,
    variable: undefined,
    code: 'DBA_25'
  },
  INVALID_ACCOUNT_BEGINNING: {
    message: 'Conta inválida. O inicio da conta {{accountBeginning}} não é reconhecido como um tipo válido.',
    field: 'account',
    variable: 'accountBeginning',
    code: 'DBA_26'
  },
  INVALID_LEGAL_DOCUMENT: {
    message: 'CNPJ {{document}} inválido',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_27'
  },
  INVALID_PHYSICAL_DOCUMENT: {
    message: 'CPF {{document}} inválido',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_28'
  },
  AGENCY_ACCOUNT_TYPE_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Agência, tipo da conta, conta ou dígito verificador da conta inválido.',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_29'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Agência, Conta ou dígito verificador da conta inválido.',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_30'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID_2: {
    message: 'Agência, conta ou dígito verificador da conta inválido.',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_30'
  },
  PROVIDED_BANK_ID_AND_CODE: {
    message:
      'Recebedor informado com ID e código do banco (bank_id e bank_code), por favor informe somente o ID ou somente o código.',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_31'
  },
  ACCOUNT_IS_JUST_FOR_CNPJ: {
    message: 'O número da conta informada pertence a uma empresa (CNPJ).',
    field: 'account',
    variable: undefined,
    code: 'DBA_32'
  },
  BANK_CODE_FORMAT_ERROR: {
    message: 'Código do Banco é obrigatório e deve conter no máximo 3 números',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_33'
  },
  BANK_CODE_NOT_FOUND: {
    message: 'Essa instituição bancária não está habilitada para receber pagamentos',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_34'
  },
  INVALID_NAME_LENGTH: {
    message: 'O nome deve ter no mínimo 3 caracteres',
    field: 'name',
    variable: undefined,
    code: 'DBA_35'
  },
  INVALID_BANK_ID: {
    message: 'ID do banco deve ser um número',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_36'
  },
  REQUIRED_PIX_KEY_TYPE: {
    message: 'O tipo da chave PIX é obrigatório',
    field: 'pix_key_type',
    code: 'DBA_37'
  },
  REQUIRED_PIX_KEY_VALUE: {
    message: 'O valor da chave PIX é obrigatório',
    field: 'pix_key',
    code: 'DBA_38'
  },
  INVALID_PIX_KEY_TYPE: {
    message: 'O tipo da chave PIX é inválido',
    field: 'pix_key_type',
    code: 'DBA_39'
  },
  INVALID_PIX_KEY: {
    message: 'Valor da chave PIX inválida para o tipo de chave {{pix_key_type}}',
    field: 'pix_key',
    variable: 'pix_key_type',
    code: 'DBA_40'
  }
};

module.exports = dba;
